import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Input, Form, Select, message } from 'antd';
import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';
import { scoutChatCenterServerUrl } from '../autoConfig';

const AddDebtor = () => {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const [timezone, setTimezone] = useState([
    {
      value: '',
      label: ''
    }
  ]);

  countries.registerLocale(enLocale);

  const countryOptions = Object.entries(countries.getNames('en')).map(
    ([code, name]) => ({
      label: name,
      value: code
    })
  );

  const onFinish = async (values) => {
    try {
      const response = await axios({
        method: 'post',
        url: `${scoutChatCenterServerUrl}/debtor/addDebtor`,
        data: {
          ...values
        }
      });
      if (response) {
        window.location.reload();
      }
      return response;
    } catch (error) {
      console.log(error);
      messageApi.open({
        type: 'error',
        content: error.response.data ? error.response.data.message : error.code
      });
      return [];
    }
  };

  const getTimezone = async () => {
    try {
      const response = await axios({
        method: 'get',
        url: `${scoutChatCenterServerUrl}/getAllTimezones`
      });
      return (
        response.data.data?.map((item) => ({
          value: item.office,
          label: item.office + ' ' + item.timezone
        })) || []
      );
    } catch (error) {
      console.log('error occurred fetching bot response', error);
      return [];
    }
  };

  useEffect(() => {
    const fetchTimezone = async () => {
      try {
        const newOptions = await getTimezone();
        setTimezone(newOptions);
      } catch (error) {
        console.error('Failed to fetch options', error);
      }
    };
    fetchTimezone();
  }, []);

  return (
    <div>
      <Form
        layout={{
          labelCol: {
            span: 4
          },
          wrapperCol: {
            span: 14
          }
        }}
        form={form}
        onFinish={onFinish}
      >
        <Form.Item
          name="debtorId"
          label="Debtor ID"
          rules={[
            {
              required: true,
              message: 'Please input your debtorId!'
            }
          ]}
        >
          <Input placeholder="" />
        </Form.Item>
        <Form.Item
          name="debtorName"
          label="Company Name"
          rules={[
            {
              required: true,
              message: 'Please input your Company Name!'
            }
          ]}
        >
          <Input placeholder="" />
        </Form.Item>
        <Form.Item
          name="pccCity"
          label="Office Name"
          rules={[
            {
              required: true,
              message: 'Please input your Office Name!'
            }
          ]}
        >
          <Input placeholder="" />
        </Form.Item>
        <Form.Item
          name="office"
          label="Time Zone"
          rules={[
            {
              required: true,
              message: 'Please input your Time Zone!'
            }
          ]}
        >
          <Select options={timezone} />
        </Form.Item>

        <Form.Item
          name="country"
          label="Country"
          rules={[
            {
              required: true,
              message: 'Please select your country!'
            }
          ]}
        >
          <Select showSearch placeholder="Select your country">
            {countryOptions.map((country) => (
              <Select.Option key={country.value} value={country.value}>
                {country.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item className="flex justify-center">
          <Button htmlType="submit">Submit</Button>
        </Form.Item>
      </Form>
      {contextHolder}
    </div>
  );
};

export default AddDebtor;
